import type { EmailToTaskFormApi } from "@/hooks/useEmailToTaskForm";
import { SectionBlock } from "../SectionBlock";
import { Field, SecretInput } from "./fields";

export function ResendCard({ settings, secrets, setSecret, disabled }: EmailToTaskFormApi) {
	return (
		<SectionBlock
			title="Resend"
			description="Resend receives the email for the inbound domain and notifies TaskHub through the webhook."
		>
			<div className="grid gap-4 sm:grid-cols-2">
				<Field label="Webhook signing secret" htmlFor="ett-whsec">
					<SecretInput
						id="ett-whsec"
						isSet={settings.resend_webhook_secret_set}
						hint={settings.resend_webhook_secret_hint}
						value={secrets.resend_webhook_secret}
						onChange={(v) => setSecret("resend_webhook_secret", v)}
						placeholder="whsec_..."
						disabled={disabled}
					/>
				</Field>
				<Field label="Receiving API key (optional)" htmlFor="ett-resend-key">
					<SecretInput
						id="ett-resend-key"
						isSet={settings.resend_api_key_set}
						hint={settings.resend_api_key_hint}
						value={secrets.resend_api_key}
						onChange={(v) => setSecret("resend_api_key", v)}
						placeholder="Falls back to the server's RESEND_API_KEY"
						disabled={disabled}
					/>
				</Field>
			</div>
		</SectionBlock>
	);
}
